export const styles = {
  main: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    minHeight: '100vh',
    backgroundColor: 'white'
  },
  grow: {
    flexGrow: 1
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 12
  },
  card: {
    marginTop: 30,
    maxWidth: 600,
    paddingBottom: 15
  },
  cardActions: {
    display: 'flex',
    justifyContent: 'flex-end'
  }
}



// WEBPACK FOOTER //
// ./src/pages/ChangePassword/styles.js